<template>
  <div class="pt-4 pl-4 font-light border border-t-0 border-gray-200 dark:border-gray-700 accordion-item">
    <ol class=" font-bold">
      <li style="list-style-type:decimal">
        <h3 style="text-align:justify"><span><strong>Chương trình học</strong></span></h3>
      </li>
    </ol>

    <h4 class="font-bold" style="text-align:justify"><span><strong>1.1. Lộ trình học </strong></span></h4>

    <p style="text-align:justify"><span>Khách hàng được đào tạo theo một lộ trình cụ thể trong từng giờ học đối với mỗi buổi học trên lớp và được hướng dẫn tự học tại nhà, đảm bảo được giảng dạy đúng số giờ học trên lớp của khóa học.</span>
    </p>

    <p class="font-bold" style="text-align:justify"><span><strong>Đối với ECoach 1-1</strong></span>
    </p>

    <p> </p>

    <table cellspacing="0" style="border-collapse:collapse; border:none; width:624px">
      <tbody>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:127px">
          <p class="font-bold" style="margin-left:-4px; margin-right:-4px; text-align:center">
            <span><strong>Tên khoá học</strong></span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:89px">
          <p class="font-bold" style="margin-left:-4px; margin-right:-4px; text-align:center"><span><strong>Trình độ đầu vào</strong></span>
          </p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:183px">
          <p class="font-bold" style="margin-left:-4px; margin-right:-4px; text-align:center">
            <span><strong>Trình độ</strong></span></p>

          <p class="font-bold" style="margin-left:-4px; margin-right:-4px; text-align:center">
            <span><strong>đầu ra</strong></span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:125px">
          <p class="font-bold" style="margin-left:-4px; margin-right:-4px; text-align:center">
            <span><strong>Thời lượng</strong></span></p>

          <p class="font-bold" style="margin-left:-4px; margin-right:-4px; text-align:center">
            <span><strong>buổi học</strong></span></p>
        </td>
        <td class="font-bold"
            style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:100px">
          <p style="margin-left:-4px; margin-right:-4px; text-align:center"><span><strong>Số</strong></span></p>

          <p style="margin-left:-4px; margin-right:-4px; text-align:center"><span><strong>buổi học</strong></span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:127px">
          <p style="text-align:center"><span>Basic</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:89px">
          <p style="text-align:center"><span>Pre A1</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:183px">
          <p style="text-align:center"><span>A1 (Tương đương 7 điểm bài thi cuối kì)</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:125px">
          <p style="text-align:center"><span>120 phút</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:100px">
          <p style="text-align:center"><span>14</span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:127px">
          <p style="text-align:center"><span>Pre IELTS</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:89px">
          <p style="text-align:center"><span>A1</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:183px">
          <p style="text-align:center"><span>A2 (IELTS 3.5)</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:125px">
          <p style="text-align:center"><span>120 phút</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:100px">
          <p style="text-align:center"><span>14</span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:127px">
          <p style="text-align:center"><span>IELTS 3.5-4.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:89px">
          <p style="text-align:center"><span>3.5 IELTS</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:183px">
          <p style="text-align:center"><span>4.5 IELTS</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:125px">
          <p style="text-align:center"><span>120 phút</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:100px">
          <p style="text-align:center"><span>16</span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:127px">
          <p style="text-align:center"><span>IELTS 4.5-5.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:89px">
          <p style="text-align:center"><span>4.5 IELTS</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:183px">
          <p style="text-align:center"><span>5.5 IELTS</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:125px">
          <p style="text-align:center"><span>120 phút</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:100px">
          <p style="text-align:center"><span>24</span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:127px">
          <p style="text-align:center"><span>IELTS 5.5-6.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:89px">
          <p style="text-align:center"><span>5.5 IELTS</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:183px">
          <p style="text-align:center"><span>6.5 IELTS</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:125px">
          <p style="text-align:center"><span>120 phút</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:100px">
          <p style="text-align:center"><span>18</span></p>
        </td>
      </tr>
      </tbody>
    </table>

    <p> </p>

    <p class="font-bold" style="text-align:justify"><span><strong>Đối với ECoach 1-6</strong></span>
    </p>

    <p> </p>

    <table cellspacing="0" style="border-collapse:collapse; border:none; width:622px">
      <tbody>
      <tr class="font-bold">
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:130px">
          <p style="margin-left:-4px; margin-right:-4px; text-align:center"><span><strong>Tên khoá học</strong></span>
          </p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:83px">
          <p style="margin-left:-4px; margin-right:-4px; text-align:center">
            <span><strong>Trình độ đầu vào</strong></span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:187px">
          <p style="margin-left:-4px; margin-right:-4px; text-align:center"><span><strong>Trình độ</strong></span></p>

          <p style="margin-left:-4px; margin-right:-4px; text-align:center"><span><strong>đầu ra</strong></span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:126px">
          <p style="margin-left:-4px; margin-right:-4px; text-align:center"><span><strong>Thời lượng</strong></span></p>

          <p style="margin-left:-4px; margin-right:-4px; text-align:center"><span><strong>buổi học</strong></span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:96px">
          <p style="margin-left:-4px; margin-right:-4px; text-align:center"><span><strong>Số</strong></span></p>

          <p style="margin-left:-4px; margin-right:-4px; text-align:center"><span><strong>buổi học</strong></span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:130px">
          <p style="text-align:center"><span>Basic (Giao tiếp nền tảng)</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:83px">
          <p style="text-align:center"><span>Pre-A1</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:187px">
          <p style="text-align:center"><span>A1 (Tương đương 7 điểm bài thi cuối kì)</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:126px">
          <p style="text-align:center"><span>90 phút / 1 buổi</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:96px">
          <p style="text-align:center"><span>24</span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:middle; width:130px">
          <p style="margin-left:-4px; margin-right:-4px; text-align:center"><span>Giao tiếp cơ bản</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:83px">
          <p style="text-align:center"><span>A1</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:187px">
          <p style="text-align:center"><span>A2 (Tương đương 7 điểm bài thi cuối kì)</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:126px">
          <p style="text-align:center"><span>90 phút / 1 buổi</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:96px">
          <p style="text-align:center"><span>36</span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:130px">
          <p style="text-align:center"><span>IELTS</span></p>

          <p style="text-align:center"><span>3.5 – 4.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:83px">
          <p style="text-align:center"><span>3.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:187px">
          <p style="text-align:center"><span>4.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:126px">
          <p style="text-align:center"><span>90 phút / 1 buổi</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:96px">
          <p style="text-align:center"><span>29</span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:130px">
          <p style="text-align:center"><span>IELTS</span></p>

          <p style="text-align:center"><span>4.5 – 5.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:83px">
          <p style="text-align:center"><span>4.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:187px">
          <p style="text-align:center"><span>5.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:126px">
          <p style="text-align:center"><span>180 phút / 1 buổi</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:96px">
          <p style="text-align:center"><span>24</span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:130px">
          <p style="text-align:center"><span>IELTS</span></p>

          <p style="text-align:center"><span>5.5 – 6.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:83px">
          <p style="text-align:center"><span>5.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:187px">
          <p style="text-align:center"><span>6.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:126px">
          <p style="text-align:center"><span>180 phút / 1 buổi</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:96px">
          <p style="text-align:center"><span>19</span></p>
        </td>
      </tr>
      </tbody>
    </table>

    <p> </p>

    <h4 class="font-bold" style="text-align:justify"><span><strong>1.2. Nội dung khóa học</strong></span><span> </span>
    </h4>

    <p style="text-align:justify"><span>Nội dung khóa học mà Khách hàng đăng ký học dựa trên các giáo trình được dùng cho việc giảng dạy tiếng Anh của các nhà xuất uy tín trên thế giới, bao gồm: Cambridge, Pearson, Oxford, Longman và được biên soạn bởi đội ngũ có chức năng nghiên cứu và phát triển khóa học của ECoach để phù hợp với trình độ của khóa học.</span>
    </p>

    <h4 class="font-bold" style="text-align:justify"><span><strong>1.3. Lịch học</strong></span></h4>

    <p><span>- Đối với ECoach 1-1, Khách hàng chọn lịch học 02 buổi/ tuần hoặc 04 buổi/ tuần;</span></p>
    <p><span>- Đối với ECoach 1-6, Khách hàng được đào tạo chính 02 buổi/ tuần;</span></p>
    <p><span>- Lịch học của Khách hàng được Trung tâm sắp xếp cố định các ngày sau đây: Thứ 2 – Thứ 5; Thứ 3 – Thứ 6; Thứ 4 -Thứ 7. </span>
    </p>
    <p><span>- Ca 1: Bắt đầu từ 18h00 đến 19h30; Ca 2: Bắt đầu từ 19h45 đến 21h15. (Đối với khóa giao tiếp và khóa IELTS từ Pre IELTS - IELTS 4.5); Khóa IELTS từ 4.5 – 6.5 bắt đầu từ 18h00 đến 21h00.</span>
    </p>

    <h4 class="font-bold" style="text-align:justify"><span><strong>1.4. Phương pháp học</strong></span></h4>

    <p style="margin-right:13px; text-align:justify"><span>Khách hàng được đào tạo theo phương pháp Active Learning trong xuyên suốt khoá học. Lợi ích mà Khách hàng nhận được từ phương pháp này cụ thể như sau:</span>
    </p>


    <p><span>- Khách hàng được cung cấp đầy đủ công cụ học tập bao gồm: 01 hộp tri thức, 01 bản đồ học tập, 01 sổ học viên, 01 tập mindmap sổ tay công thức dán tường, 01 bộ giáo trình, và 01 hợp đồng;</span>
    </p>
    <p><span>- Học tập trên lớp qua hệ thống slide bài giảng hấp dẫn, trực quan;</span></p>
    <p><span>- Ôn tập qua các hoạt động game thú vị, sáng tạo;</span></p>
    <p><span>- Học từ vựng thông qua kho clip reaction;</span></p>
    <p><span>- Học tập theo nhóm với sĩ số lớp học tối đa 06 học viên/ lớp;</span></p>
    <p><span>- Tham gia học tập qua các hoạt động nhóm trên lớp, qua các giải đấu, qua các buổi sinh hoạt Câu Lạc Bộ hàng tháng;</span>
    </p>
    <p><span>- Được cung cấp ứng dụng học tập giúp Khách hàng tự ôn luyện tại nhà; ứng dụng gồm hệ thống bài tập về nhà, phòng luyện từ vựng, phòng luyện tốc độ, phòng luyện thi;</span>
    </p>
    <p><span>- Được tham gia các buổi Workshop với các Diễn giả là chuyên gia hàng đầu về kỹ năng sống, phương pháp học tập và định hướng tương lai.</span>
    </p>


    <h4 class="font-bold" style="text-align:justify"><span><strong>1.5. Tiêu chuẩn giảng viên</strong></span></h4>

    <table cellspacing="0" style="border-collapse:collapse; border:none; width:605px">
      <tbody>
      <tr class="font-bold">
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:53px">
          <p style="text-align:center"><span><strong>STT</strong></span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:133px">
          <p style="text-align:center"><span><strong>Khoá học</strong></span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:419px">
          <p style="text-align:center"><span><strong>Tiêu chuẩn giảng viên</strong></span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:53px">
          <p style="text-align:center"><span>1</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:133px">
          <p style="text-align:center"><span>Giao tiếp</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:419px">
          <p style="text-align:justify">
            <span>- Giáo viên đạt chứng chỉ IELTS tối thiểu 6.5 / C1 VSTEP/ TOEIC 700.</span>
          </p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:53px">
          <p style="text-align:center"><span>2</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:133px">
          <p style="text-align:center"><span>IELTS 3.5-4.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:419px">
          <p style="text-align:justify"><span>- Giáo viên đạt chứng chỉ 7.0 IELTS trở lên.</span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:53px">
          <p style="text-align:center"><span>3</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:133px">
          <p style="text-align:center"><span>IELTS 4.5-5.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:419px">
          <p style="text-align:justify"><span>- Giáo viên đạt chứng chỉ 7.5 IELTS trở lên.</span></p>
        </td>
      </tr>
      <tr>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:53px">
          <p style="text-align:center"><span>4</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:133px">
          <p style="text-align:center"><span>IELTS 5.5-6.5</span></p>
        </td>
        <td style="border-bottom:1px solid #000000; border-left:1px solid #000000; border-right:1px solid #000000; border-top:1px solid #000000; vertical-align:top; width:419px">
          <p style="text-align:justify"><span>- Giáo viên đạt chứng chỉ 7.5 IELTS trở lên.</span></p>
        </td>
      </tr>
      </tbody>
    </table>
    <h4 class="font-bold mt-3" style="text-align:justify">
      <span><strong>1.6. Kiểm tra giữa khóa và cuối khóa</strong></span>
    </h4>
    <p><span>- Giữa và cuối mỗi khóa học, Trung tâm có quyền tổ chức kiểm tra để đánh giá trình độ học viên trong khóa. Kỳ kiểm tra cuối khóa sẽ do bộ phận kiểm tra đánh giá trực tiếp kiểm tra trình độ. Khách hàng cần tham gia buổi kiểm
      tra cuối khóa mới được đánh giá là hoàn thành khóa học và được tham gia học khóa học tiếp theo nếu đủ điểm đầu vào.</span>
    </p>
    <p><span>- Trường hợp Khách hàng không tham gia làm bài kiểm tra giữa khóa, cuối khóa học vì có lý do chính đáng và được Trung tâm chấp nhận, bộ phận kiểm tra đánh giá của Trung tâm sẽ sắp xếp lịch cho Khách hàng kiểm tra lại miễn
    phí trong vòng một tuần tính từ ngày kiểm tra trình độ lần 1. Trong đó, các lý do nghỉ kiểm tra chính đáng được Trung tâm chấp nhận bao gồm:</span>
    </p>
    <p class="pl-5">
      <span>
        <span>
      + Có vấn đề sức khỏe dẫn đến việc không thể tham gia kiểm tra và có giấy xác nhận của cơ quan y tế;
      </span>
      </span>
    </p>
    <p class="pl-5">
      <span>
        <span>
      + Lý do liên quan đến công việc (có giấy xác nhận của công ty), học tập (có xác nhận của trường học) dẫn đến việc không thể tham gia kiểm tra.
      </span>
      </span>
    </p>

    <p>
      <span>- Nếu Khách hàng không sắp xếp tham gia kiểm tra được trong thời gian này, mức phí phục vụ Khách hàng thi bổ sung là 100.000 VNĐ (Một trăm nghìn đồng Việt Nam) cho mỗi lần thi.</span>
    </p>
    <p>
      <span>- Trường hợp Khách hàng không tham gia làm bài thi giữa khóa, cuối khóa không thuộc lý do chính đáng được Trung tâm chấp nhận;
        hoặc có nhu cầu thi lại, mức phí phục vụ Khách hàng thi bổ sung là 100.000 VNĐ (Một trăm nghìn đồng Việt Nam) cho mỗi lần thi.</span>
    </p>
    <ol class=" font-bold mt-2" start="2">
      <li style="list-style-type:decimal">
        <h3 style="text-align:justify"><span><strong>Chương trình Workshop, Câu lạc bộ</strong></span></h3>
      </li>
    </ol>

    <p class="font-bold" style="text-align:justify"><span><strong>2.1. Mô tả</strong></span></p>

    <p><span>- Mỗi quý ECoach sẽ tổ chức 1-2 buổi Câu lạc bộ và 1 -2 buổi Workshop cho các Khách hàng.</span>
    </p>
    <p><span>- Lệ phí: Miễn phí</span></p>

    <p class="font-bold" style="text-align:justify"><span><strong>2.2. Hình thức học</strong></span></p>
    <p><span>- Online</span></p>

    <p class="font-bold" style="text-align:justify"><span><strong>2.3. Thời lượng</strong></span></p>

    <p><span>- 120-180 phút/ 01 buổi</span></p>


    <p class="font-bold" style="text-align:justify"><span><strong>2.4. Nội dung chương trình</strong></span></p>


    <p><span>- Chương trình học do Trung tâm sắp xếp.</span></p>
    <p><span>- Trung tâm sẽ thông báo tới Khách hàng về chủ đề và các thông tin liên quan đến chương trình Workshop, Câu lạc bộ tối thiểu 01 tuần trước ngày diễn ra chương trình.</span>
    </p>

    <p class="font-bold" style="text-align:justify"><span><strong>2.5. Thời gian</strong></span></p>

    <p><span>- Theo thời gian Trung tâm sắp xếp.</span></p>
    <p><span>- Trung tâm sẽ thông báo tới Khách hàng về thời gian chương trình Workshop, Câu lạc bộ tối thiểu 01 tuần trước ngày diễn ra chương trình.</span>
    </p>

    <ol class=" font-bold" start="3">
      <li style="list-style-type:decimal">
        <h3 style="text-align:justify"><span><strong>Chính sách bảo hành</strong></span></h3>
      </li>
    </ol>

    <h4 class="font-bold" style="text-align:justify">
      <span><strong>3.1. Quy định trong chính sách bảo hành</strong></span></h4>

    <p style="text-align:justify"><span>Khách hàng cam kết thực hiện đúng những quy định sau đây:</span></p>

    <p><span>- Đảm bảo đạt chuẩn theo yêu cầu đầu vào đối với khóa học đã đăng ký của ECoach. Trong đó, “Đầu vào khoá học” được hiểu là điểm của Khách hàng đối với bài thi kiểm tra đầu vào do ECoach tổ chức hoặc điểm thi cuối khóa (có giá trị trong 90 ngày kể từ ngày có điểm thi) của Khách hàng đối với khóa học của ECoach mà Khách hàng tham gia học trước đó.</span>
    </p>
    <p><span>- Thanh toán đầy đủ phí dịch vụ theo phiếu đăng ký học tập tại ECoach;</span></p>
    <p><span>- Liên hệ trao đổi cùng với Trung tâm để được xếp lớp thời gian phù hợp nhất với Khách hàng;</span></p>
    <p><span>- Tuân thủ nghiêm túc quy định của khóa học;</span></p>
    <p><span>- Tham gia đầy đủ, nghiêm túc các buổi học theo quy định sau:</span></p>

    <p class="pl-5"><span>+ Chỉ được nghỉ tối đa 02 (hai) buổi học/ khóa học bao gồm có phép và không phép (Khách hàng được phép nghỉ thêm </span><span><strong>tối đa 2 buổi</strong></span><span> có phép hoặc không phép trong trường hợp bất khả kháng gồm: mất kết nối Internet trên diện rộng và Khách hàng cung cấp được bằng chứng phù hợp theo yêu cầu của ECoach. Trong trường hợp nghỉ học bất khả kháng này, Khách hàng bắt buộc tham gia học phụ đạo theo sự sắp xếp của ECoach); </span>
    </p>
    <p class="pl-5"><span>+ Không được vào lớp muộn quá </span><span><strong>15 phút</strong></span><span> và/hoặc kết thúc lớp học sớm trước 15 phút, nếu vi phạm sẽ được coi là nghỉ buổi học đó;</span>
    </p>
    <p class="pl-5"><span>+ Hoàn thành đầy đủ</span><span><strong> 100% bài tập về nhà đúng hạn</strong></span><span> trên APP và giáo viên giao. Trong đó, sau mỗi buổi học, khi hoàn thành bài tập về nhà trên APP của Trung tâm đúng hạn, Khách hàng được giảng viên chấm và nhận xét chi tiết. Trường hợp gặp vấn đề về lỗi APP, Khách hàng cần liên hệ Zalo CSKH ECoach (được tham gia trong quá trình học tập) trước thời hạn bài tập về nhà 02 tiếng để được hỗ trợ kịp thời.</span>
    </p>
    <p class="pl-5"><span>+ Tham gia đầy đủ và làm bài trung thực các buổi kiểm tra giữa khóa và cuối khóa, buổi kiểm tra được xem như một buổi học chính thức.</span>
    </p>
    <p class="pl-5"><span>+ Bật camera và mở mic trả lời câu hỏi trong suốt giờ học;</span></p>
    <p class="pl-5"><span>+ Tham gia tích cực vào các hoạt động do giáo viên tổ chức;</span></p>

    <p><span>- Khách hàng phải tuyệt đối bảo mật, không tự ý cung cấp tài liệu nội bộ của ECoach ra bên ngoài;</span>
    </p>
    <p><span>- Trong quá trình sử dụng dịch vụ Khách hàng phải tuân theo các nội quy, nguyên tắc, quy chế Trung tâm và pháp luật hiện hành. Không được cung cấp thông tin sai lệch ảnh hưởng tới danh tiếng của ECoach;</span>
    </p>
    <p><span>- Cập nhật phương thức liên hệ (bao gồm số điện thoại, email) cho ECoach qua hotline 1900 4782 hoặc Zalo CSKH ECoach (được tham gia trong quá trình học tập) trong 01 (Một) ngày kể từ thời điểm Khách hàng có sự thay đổi;</span>
    </p>
    <p><span>- Khách hàng tối thiểu phải hoàn thành 100% học phí khóa học liền sau khóa học sắp được xếp lớp trước thời điểm khóa học khai giảng mới đảm bảo đủ điều kiện được nhập học khóa học.</span>
    </p>
    <p><span>- Khách hàng có nghĩa vụ tham gia lớp học mà ECoach đã liên hệ xếp lớp thành công. Sau khi Khách hàng đã đồng ý tham gia lớp học ECoach sắp xếp dựa trên sự đồng thuận của 02 bên, Khách hàng không được phép đổi khóa, chuyển lớp vì bất kỳ lý do gì. </span>
    </p>

    <h4 class=" font-bold" style="text-align:justify"><span><strong>3.2. Nội dung chính sách bảo hành</strong></span>
    </h4>

    <p><span>- Đối với khóa học IELTS cuối cùng trong Combo Khách hàng đăng ký, trong vòng tối đa 30 ngày liên tục kể từ khi kết thúc khoá học, nếu Khách hàng tham gia thi IELTS tại Hội đồng Anh hoặc Tổ chức IDP sau khi kết thúc khóa học IELTS; nhưng Khách hàng không đạt được điểm số tương đương với điểm chuẩn đầu ra của khóa học, ECoach sẽ xử lý như sau:</span>
    </p>

    <ul class="pl-10">
      <li style="list-style-type:disc">
        <span>Khách hàng được học lại miễn phí đối với khóa học gần nhất mà Khách hàng học của ECoach trước khi tham gia thi trong trường hợp Khách hàng thực hiện đúng, đầy đủ các nghĩa vụ tại mục </span><a
          href="javascript:void(0)"
          style="text-decoration:none"><span style="color:#1155cc"><u>3.1. Quy định trong chính sách bảo hành</u></span></a><span> của điều khoản dịch vụ này.
        Tại mỗi lần học lại, khi tham gia thi lại tại Hội đồng Anh hoặc Tổ chức IDP, nhưng không đạt được điểm số tương đương với điểm chuẩn đầu ra, Khách hàng tiếp tục được học lại miễn phí, trong trường hợp ở mỗi lần học lại, Khách hàng thực hiện đúng, đầy đủ các nghĩa vụ tại mục 3.1. Quy định trong chính sách bảo hành.
      </span>
      </li>
      <li style="list-style-type:disc"><span>Tiến hành kiểm tra lại trình độ cho Khách hàng, hỗ trợ Khách hàng đăng ký học lại khóa học của ECoach phù hợp với trình độ sau kiểm tra và Khách hàng phải đóng 100% phí dịch vụ của khóa học theo mức giá Khách hàng lẻ niêm yết tại thời điểm đó trong trường hợp Khách hàng không đáp ứng đầy đủ các nghĩa vụ được quy định tại mục </span><a
          href="javascript:void(0)"
          style="text-decoration:none"><span style="color:#1155cc"><u>3.1. Quy định trong chính sách bảo hành</u></span></a><span> của điều khoản dịch vụ này nhưng có mong muốn học lại.</span>
      </li>
    </ul>

    <p class="pl-5">
        <span>
          + Trường hợp đặc biệt, trong vòng 30 ngày liên tục đó không có bất cứ kỳ thi IELTS nào được Hội đồng Anh và Tổ chức IDP tổ chức tại khu vực Tỉnh/ Thành mà Khách hàng đang sinh sống, Khách hàng có thêm 30 ngày để chuẩn bị tham gia thi IELTS ở các khu vực Tỉnh/ Thành lân cận;
        </span>
    </p>
    <p class="pl-5">
      <span>
        <span>
      + Trường hợp Trung tâm được miễn trừ trách nhiệm: IDP và Hội đồng Anh tạm ngưng tổ chức kỳ thi IELTS trên tất cả Tỉnh/ Thành quá 60 ngày bắt đầu từ thời điểm IDP và Hội đồng Anh thông báo chính thức.
      </span>
      </span>
    </p>

    <p><span>- Đối với các khóa IELTS không phải là khoá học cuối trong Combo của Khách hàng, nếu Khách hàng tham gia thi cuối khoá do Trung tâm tổ chức nhưng Khách hàng không đạt được điểm số tương đương với điểm chuẩn đầu ra của khoá học thì sẽ xử lý như sau: </span>
    </p>

    <ul class="pl-10">
      <li style="list-style-type:disc">
        Khách hàng được Trung tâm sắp xếp, tổ chức giảng dạy và ôn tập lại miễn phí đến khi đạt điểm số tương đương với
        điểm chuẩn đầu ra trước khi Khách hàng học lên khoá tiếp theo trong trường hợp Khách hàng thực hiện đúng, đầy đủ
        các nghĩa vụ tại mục
        <a
            href="javascript:void(0)"
            style="color:#1155cc"><span><u>3.1. Quy định trong chính sách bảo hành</u></span></a>
        của điều khoản dịch vụ này;
      </li>
      <li style="list-style-type:disc"><span>Tiến hành kiểm tra lại trình độ cho Khách hàng, hỗ trợ Khách hàng đăng ký học lại khóa học của ECoach phù hợp với trình độ sau kiểm tra và Khách hàng phải đóng 100% phí dịch vụ của khóa học theo mức giá Khách hàng lẻ niêm yết tại thời điểm đó trong trường hợp Khách hàng không đáp ứng đầy đủ các nghĩa vụ được quy định tại mục </span>
        <a href="javascript:void(0)"
           style="text-decoration:none"><span
            style="color:#1155cc"><u>3.1. Quy định trong chính sách bảo hành</u></span></a><span> của điều khoản dịch vụ này nhưng có mong muốn học lại.</span>
      </li>
    </ul>
    <p style="list-style-type:disc"><span>- Đối với khoá giao tiếp, nếu Khách hàng tham gia kỳ thi cuối khoá do ECoach tổ chức sau khi kết thúc khóa học và không đạt được điểm chuẩn đầu ra của khoá đó thì ECoach sẽ xử lý như sau:</span>
    </p>
    <ul class="pl-10">
      <li style="list-style-type:disc">
        Khách hàng được Trung tâm sắp xếp, tổ chức giảng dạy và ôn tập lại miễn phí đến khi đạt điểm số tương đương với
        điểm chuẩn đầu ra trước khi Khách hàng học lên khoá tiếp theo trong trường hợp Khách hàng thực hiện đúng, đầy đủ
        các nghĩa vụ tại mục
        <a
            href="javascript:void(0)"
            style="color:#1155cc"><span><u>3.1. Quy định trong chính sách bảo hành</u></span></a>
        của điều khoản dịch vụ này;
      </li>
      <li style="list-style-type:disc"><span>Tiến hành kiểm tra lại trình độ cho Khách hàng, hỗ trợ Khách hàng đăng ký học lại khóa học của ECoach phù hợp với trình độ sau kiểm tra và giảm tối đa 50% phí dịch vụ của khóa học đó trong trường hợp Khách hàng không đáp ứng đầy đủ các nghĩa vụ được quy định tại mục </span>
        <a
          href="javascript:void(0)"
          style="color:#1155cc"><span><u>3.1. Quy định trong chính sách bảo hành</u></span></a><span> của điều khoản dịch vụ này nhưng có mong muốn học lại.</span>
      </li>
    </ul>

    <p><span>- Giữa và cuối mỗi khóa học, ECoach có quyền tổ chức kiểm tra để đánh giá trình độ cho các học viên trong khóa. Trong đó, kỳ kiểm tra cuối khóa sẽ do bộ phận kiểm tra đánh giá của ECoach trực tiếp kiểm tra trình độ cho Khách hàng. Nếu nghỉ không quá 20% số buổi học của khóa học, Khách hàng bắt buộc phải tham gia buổi kiểm tra cuối khóa mới được đánh giá là hoàn thành khóa học và được tham gia học khóa học tiếp theo nếu đủ điểm đầu vào; nếu nghỉ hơn 20% số buổi của khóa học, Khách hàng có thể không cần tham gia kỳ kiểm tra cuối khóa hoặc có tham gia nhưng không được công nhận điểm số để thực hiện các quyền lợi của mình;</span>
    </p>

    <p style="text-align:justify"><span class="font-bold"><strong>Lưu ý</strong></span><span>: Số buổi học Khách hàng tham gia học được làm tròn lên một đơn vị trong trường hợp giá trị sau dấu phẩy lớn hơn 5 (Năm).</span>
    </p>

    <p><span>- Trong trường hợp Khách hàng không tham gia làm bài kiểm tra cuối khóa học vì có lý do chính đáng và được ECoach chấp nhận, bộ phận kiểm tra đánh giá của ECoach sẽ sắp xếp lịch cho Khách hàng kiểm tra lại miễn phí trong vòng một tuần tính từ ngày kiểm tra trình độ lần 1. Nếu Khách hàng không sắp xếp tham gia kiểm tra được trong thời gian này, Khách hàng phải chịu mức phí thi bổ sung là 100.000 VNĐ </span><span><em>(Một trăm nghìn đồng Việt Nam)</em></span><span> cho mỗi lần thi. Trong đó, các lý do nghỉ kiểm tra chính đáng được ECoach chấp nhận bao gồm:</span>
    </p>

    <p class="pl-5"><span>+ Có vấn đề sức khỏe dẫn đến việc không thể tham gia kiểm tra và có giấy xác nhận của cơ quan y tế;</span>
    </p>
    <p class="pl-5"><span>+ Lý do liên quan đến công việc (có giấy xác nhận của công ty), học tập (có xác nhận của trường học) dẫn đến việc không thể tham gia kiểm tra.</span>
    </p>

    <ol class=" font-bold" start="4">
      <li style="list-style-type:decimal">
        <h3 style="text-align:justify"><span><strong>Chính sách đổi khóa học</strong></span></h3>
      </li>
    </ol>

    <p style="text-align:justify"><span>ECoach đồng ý hỗ trợ đổi khoá học cho Khách hàng trong trường hợp khóa học Khách hàng đã đăng ký chưa bắt đầu học. Trong trường hợp này, Khách hàng sẽ phải trả thêm mức giá chênh lệch (nếu có) giữa khoá học đã đăng ký và khoá học mong muốn đổi theo mức giá bán lẻ niêm yết tại thời điểm đó; nếu khóa học Khách hàng mong muốn được đổi có mức giá bán lẻ niêm yết thấp hơn khóa học bị đổi, Khách hàng sẽ không được hoàn lại phần phí chênh lệch này.</span>
    </p>

    <ol class=" font-bold" start="5">
      <li style="list-style-type:decimal">
        <h3 style="text-align:justify"><span><strong>Chính sách chuyển nhượng khóa học</strong></span></h3>
      </li>
    </ol>

    <p><span>- Khi có nhu cầu chuyển nhượng, Khách hàng đến trực tiếp Trung tâm hoặc liên hệ bộ phận có thẩm quyền (quản lý Khách hàng hoặc Trung tâm hỗ trợ) của Trung tâm để được hướng dẫn thủ tục. </span>
    </p>
    <p><span>- Khách hàng được quyền chuyển nhượng các khoá học khi hoàn tất thủ tục chuyển nhượng trước 01 ngày Khai giảng khóa học diễn ra. </span>
    </p>
    <p><span>- Khách hàng được chuyển nhượng 01 lần duy nhất/ khóa học hoặc nhóm khóa học (combo) và được chuyển nhượng cho 01 người duy nhất.</span>
    </p>
    <p><span>- Khách hàng phải tìm người chuyển nhượng khóa học của mình để hoàn tất thủ tục chuyển nhượng.</span></p>
    <p><span>- Với trường hợp Khách hàng đã được xếp lớp, người được Khách hàng chuyển nhượng cần có trình độ đầu vào cùng với trình độ đầu vào của Khách hàng (thông qua bài thi kiểm tra đầu vào do ECoach tổ chức) và phải học ngay khóa học đã được xếp đó.</span>
    </p>
    <p><span>- Với trường hợp Khách hàng chưa được xếp lớp, người được Khách hàng chuyển nhượng có thể chênh lệch trình độ đầu vào. </span>
    </p>

    <p class="pl-5"><span>+ Trường hợp người được chuyển nhượng có trình độ đầu vào thấp hơn Khách hàng: Thông qua kết quả kiểm tra đầu vào do ECoach tổ chức, người được chuyển nhượng cần hoàn thành 100% phí dịch vụ và bắt đầu từ khóa học tương ứng với kết quả đầu vào thời điểm đó.</span>
    </p>
    <p class="pl-5"><span>+ Trường hợp người được chuyển nhượng có trình độ cao hơn Khách hàng: Thông qua kết quả kiểm tra đầu vào do ECoach tổ chức, người được chuyển nhượng cần bắt đầu từ khóa học tương ứng với kết quả đầu vào thời điểm đó.</span>
    </p>

    <p><span>- Khách hàng chỉ được quyền chuyển nhượng khi đã hoàn thành 100% phí dịch vụ với Trung tâm.</span></p>
    <p><span>- Chính sách chuyển nhượng này không áp dụng cho các chương trình khuyến mãi đặc biệt vào các dịp khai trương và Flash sale.</span>
    </p>

    <ol class=" font-bold" start="6">
      <li style="list-style-type:decimal">
        <h3 style="text-align:justify"><span><strong>Chính sách bảo lưu</strong></span></h3>
      </li>
    </ol>

    <p><span>- Trung tâm hỗ trợ Khách hàng thực hiện việc bảo lưu khóa học xuyên suốt khóa học với điều kiện Khách hàng không nghỉ học 05 buổi liên tục (bao gồm có phép và không phép) và Khách hàng đã hoàn thành đủ 100% phí dịch vụ;</span>
    </p>

    <p><span>- Chi phí bảo lưu cho khóa học là 50% phí dịch vụ của khóa học theo mức giá gốc tại thời điểm Khách hàng đăng ký khóa học. </span>
    </p>
    <p><span>- Trong trường hợp đặc biệt: Khách hàng thực hiện việc bảo lưu vì điều kiện bất khả kháng, chi phí bảo lưu khóa học là 35% phí dịch vụ của khóa học theo mức giá gốc tại thời điểm Khách hàng đăng ký khóa học. Các trường hợp bất khả kháng bao gồm: có vấn đề sức khỏe, cần nằm viện liên tục nhiều hơn 20 ngày dẫn đến không thể tham gia lớp học, có giấy xác nhận của cơ quan y tế; hoặc Khách hàng nhận được lịch đi học quân sự từ Nhà trường (phải ở lại khu quân sự nhiều hơn 20 ngày) mà Khách hàng không biết trước (tính từ thời điểm Khách hàng được Trung tâm gọi xếp lớp tới thời điểm lớp khai giảng); có giấy xác nhận đi học quân sự của Nhà trường;</span>
    </p>
    <p><span>- Khách hàng chỉ được bảo lưu duy nhất một lần/ khóa học; </span></p>
    <p><span>- Thời gian bảo lưu tối đa là 90 ngày liên tục. Sau thời gian trên, nếu Khách hàng không hoàn thành thủ tục để quay trở lại học, Trung tâm vẫn bảo lưu khóa học mà Khách hàng thực hiện bảo lưu, đồng thời, Khách hàng cần tham gia kiểm tra lại trình độ đầu vào (thông qua bài thi kiểm tra đầu vào do ECoach tổ chức). Trường hợp kết quả đầu vào thấp hơn so với trình độ đầu vào của khóa học được bảo lưu, Khách hàng cần hoàn thành 100% phí dịch vụ, bắt đầu học lại từ khóa học tương ứng với kết quả đầu vào thời điểm đó.</span>
    </p>

    <p><span>- Trong trường hợp Khách hàng tự ý nghỉ học 5 buổi liên tục mà không đến làm thủ tục bảo lưu hoặc không có thông báo với Trung tâm thì Khách hàng được coi là đơn phương chấm dứt học tập, đồng thời không được hưởng bất kỳ quyền lợi nào từ Trung tâm và đương nhiên không được nhận lại phí dịch vụ của khóa học đó. Nếu Khách hàng muốn tham gia học lại khóa học này, Khách hàng phải đóng đủ 100% phí dịch vụ của khóa học theo mức giá Khách hàng lẻ niêm yết tại thời điểm đó.</span>
    </p>

    <ol class=" font-bold" start="7">
      <li style="list-style-type:decimal">
        <h3 style="text-align:justify"><span><strong>Chính sách hoàn học phí</strong></span></h3>
      </li>
    </ol>

    <h4 class="font-bold" style="text-align:justify"><span><strong>7.1. Tiếp nhận nhu cầu</strong></span></h4>

    <p style="text-align:justify"><span>Để yêu cầu hoàn lại tiền, Khách hàng vui lòng liên hệ qua kênh Zalo CSKH ECoach (được tham gia trong quá trình học tập) hoặc đến trực tiếp văn phòng giao dịch thuộc Hệ thống Trung tâm ECoach để được đội ngũ Quản lý tại điểm hỗ trợ. </span>
    </p>

    <h4 class="font-bold" style="text-align:justify"><span><strong>7.2. Điều kiện hoàn học phí</strong></span></h4>

    <p style="text-align:justify">
      <span>Khách hàng được hoàn trả phí dịch vụ trong các trường hợp (trước khóa học):</span></p>

    <p class="font-bold" style="text-align:justify">
      <span><strong>7.2.1. Trường hợp hoàn tiền 65% khi</strong></span><span>: </span></p>

    <p><span>- Khách hàng đi du học: Cần giấy xác nhận của nhà trường hoặc Thư xác nhận nhập học của trường Khách hàng chuẩn bị du học;</span>
    </p>
    <p><span>- Thay đổi địa điểm sinh sống ra nước ngoài: Cần giấy tạm trú, tạm vắng.</span></p>

    <p class="font-bold" style="text-align:justify">
      <span><strong>7.2.2. Trường hợp hoàn tiền 100% khi:</strong></span></p>

    <p><span>- Trung tâm không mở được khóa học mà Khách hàng đã đăng ký trước đó trong vòng 6 tháng bắt đầu từ thời điểm Khách hàng hoàn thành đóng học phí (với khóa học đầu tiên) hoặc từ thời điểm kết thúc khóa học liền kề với khóa học mới.</span>
    </p>
    <p><span>- Bệnh hiểm nghèo theo quy định của bảo hiểm nhà nước (Nghị định 134/2015/NĐ-CP của Chính phủ quy định chi tiết một số điều của Luật Bảo hiểm xã hội về bảo hiểm xã hội tự nguyện).</span>
    </p>
    <p><span>- Hoàn tiền trong phạm vi đối với khóa học không mở được khóa trong vòng 06 tháng đó.</span></p>

    <h4 class="font-bold" style="text-align:justify"><span><strong>7.3. Hồ sơ hoàn học ph</strong></span><span>í</span>
    </h4>

    <p><span>- Hồ sơ hoàn trả phí dịch vụ: </span></p>

    <p><span>+ Phiếu đăng ký học tập tại ECoach;</span></p>
    <p><span>+ Chứng minh nhân dân hoặc căn cước công dân của Khách hàng. Số lượng: 1 (một) bản photo;</span></p>
    <p><span>+ Giấy chứng nhận tương ứng với các lý do (Chi tiết từng trường hợp theo mục 8.2.1 và 8.2.2).</span></p>

    <p style="list-style-type:disc"><span>- Số tiền hoàn = Học phí thực đóng - Tổng chi phí khóa mà Khách hàng đã học (nếu có) - Quà tặng Khách hàng nhận theo giá niêm yết trên chương trình khuyến mãi của thời điểm Khách hàng đăng ký học (nếu có).</span>
    </p>

    <h4 class="font-bold" style="margin-left:4px; text-align:justify"><span><strong>7.4. Thời gian hoàn học phí</strong></span>
    </h4>

    <p style="list-style-type:disc"><span>- Thời gian xử lý hoàn học phí: Trong vòng 48h kể từ thời điểm tiếp nhận và nhận đầy đủ hồ sơ của Khách hàng;</span>
    </p>
    <p>
      <span>- Thời gian hoàn lại học phí: Thứ 3 và Thứ 6 hàng tuần (trừ các ngày Chủ nhật, Lễ, Tết theo quy định của Nhà nước).</span>
    </p>

    <h4 class="font-bold" style="margin-left:4px; text-align:justify"><span><strong>7.5. Hình thức hoàn học phí</strong></span>
    </h4>

    <p><span>- ECoach chỉ hỗ trợ hoàn trả phí qua hình thức chuyển khoản. Sau khi được liên hệ thông báo về việc đồng ý duyệt trả học phí thì Khách hàng vui lòng liên hệ với kênh tiếp nhận hoàn học phí tại mục </span><a
        href="javascript:void(0)"
        style="color:#1155cc"><span><u>7.1. Tiếp nhận nhu cầu</u></span></a><span> của mục </span><a
        href="javascript:void(0)"
        style="color:#1155cc"><span><u>7. Chính sách hoàn học phí</u></span></a><span> và cung cấp đầy đủ các thông tin sau: Tên ngân hàng, Số tài khoản, Tên chủ tài khoản để chuyển khoản.</span>
    </p>
    <p><span>- Tên chủ tài khoản phải khớp với tên Khách hàng. Trường hợp Khách hàng dưới 15 tuổi, Số tài khoản nhận hoàn học phí có thể là của Bố/Mẹ hoặc người giám hộ (Thông tin người giám hộ này cần trùng khớp thông tin người giám hộ tại phiếu đăng ký học tập của ECoach)</span>
    </p>

    <p style="text-align:justify"><span><em>Xin lưu ý rằng, nếu ECoach phát hiện Khách hàng đang lợi dụng chính sách hoàn trả của chúng tôi, chúng tôi có quyền từ chối xử lý hoặc hạn chế bất kỳ hay tất cả các quyền lợi học tập trong hiện tại và tương lai của Khách hàng tại ECoach, mà không chịu bất kỳ trách nhiệm pháp lý nào.</em></span>
    </p>

    <ol class="font-bold" start="8">
      <li style="list-style-type:decimal">
        <h4 style="text-align:justify"><span><strong>Trường hợp bất khả kháng</strong></span></h4>
      </li>
    </ol>

    <p style="text-align:justify"><span>- Sự kiện bất khả kháng là sự kiện xảy ra mang tính chất khách quan và nằm ngoài tầm kiểm soát của các bên (thiên tai, hỏa hoạn, lũ lụt,…) và sự thay đổi chính sách hoặc ngăn cấm của cơ quan có thẩm quyền của Nhà nước Việt Nam.</span>
    </p>

    <p style="text-align:justify"><span>- Việc một bên không hoàn thành nghĩa vụ của mình do sự kiện bất khả kháng sẽ không phải là cơ sở để bên kia chấm dứt Điều khoản dịch vụ và không bị phạt/ bồi thường Điều khoản dịch vụ khi điều chỉnh hoặc hủy dịch vụ. Tuy nhiên bên bị ảnh hưởng bởi sự kiện bất khả kháng có nghĩa vụ phải:</span>
    </p>

    <p style="text-align:justify"><span>+ Tiến hành các biện pháp ngăn ngừa hợp lý và các biện pháp thay thế cần thiết để hạn chế tối đa ảnh hưởng do sự kiện bất khả kháng gây ra.</span>
    </p>

    <p style="text-align:justify"><span> + Thông báo ngay cho bên kia về sự kiện bất khả kháng và nếu bên B muốn điều chỉnh hoặc hủy dịch vụ hoặc thay đổi thời gian sử dụng dịch vụ phải thông báo cho bên A trước 48 giờ.</span>
    </p>

    <p style="text-align:justify"><span>+ Trong trường hợp xảy ra sự kiện bất khả kháng, thời gian thực hiện Điều khoản dịch vụ sẽ được kéo dài bằng thời gian diễn ra sự kiện bất khả kháng mà bên bị ảnh hưởng không thể thực hiện các nghĩa vụ theo Điều khoản dịch vụ của mình.</span>
    </p>

    <ol class="font-bold" start="9">
      <li style="list-style-type:decimal">
        <h4 style="text-align:justify"><span><strong>Luật áp dụng và giải quyết tranh chấp</strong></span></h4>
      </li>
    </ol>

    <p style="text-align:justify"><span>Khi phát sinh tranh chấp, Trung tâm và Khách hàng cùng thống nhất áp dụng pháp luật Việt Nam để giải quyết;</span>
    </p>

    <p style="text-align:justify"><span>Mọi tranh chấp phát sinh liên quan đến Điều khoản dịch vụ này trước hết sẽ được giải quyết thông qua thương lượng và hòa giải giữa các bên;</span>
    </p>

    <p style="text-align:justify"><span>Trong trường hợp hòa giải không thành thì một trong các bên có quyền yêu cầu Tòa án có thẩm quyền giải quyết;</span>
    </p>

    <p style="text-align:justify"><span>Các nội dung chưa được quy định tại Điều khoản dịch vụ sẽ được thực hiện theo các quy định của Pháp luật, bao gồm cả quyền và trách nhiệm của các bên.</span>
    </p>

    <ol class="font-bold" start="10">
      <li style="list-style-type:decimal">
        <h4 style="text-align:justify"><span><strong>Các thay đổi</strong></span></h4>
      </li>
    </ol>
    <p style="text-align:justify"><span>Các thay đổi
Điều khoản dịch vụ của ECoach có thể sẽ thay đổi trong từng thời điểm để phục vụ việc nâng cấp trải nhiệm Khách hàng. ECoach sẽ công bố rõ ràng bất kỳ sự thay đổi nào về Điều khoản dịch vụ trên Website hoặc các kênh truyền thông chính thức khác của ECoach, và thông báo nổi bật với những thay đổi quan trọng. Đồng thời, Khách hàng sẽ thực hiện theo những Điều khoản dịch vụ được thay đổi đó của ECoach, kể từ thời điểm ECoach công bố trên Website hoặc các kênh truyền thông chính thức khác.</span>
    </p>
    <p> </p>

    <p class="font-bold" style="text-align:justify"><span><strong><em>Trong trường hợp gặp các sự cố không mong muốn hoặc có vấn đề cần phản ánh, Khách hàng có thể liên hệ tới Tổng đài 1900 4782 để được hỗ trợ.</em></strong></span>
    </p>

    <p> </p>

    <ol>
    </ol>

    <p> </p>

  </div>

</template>

<script>
export default {
  name: "ecoach_collapse_chinh_sach_hoc_tap"
}
</script>

<style scoped>
li::marker {
  font-size: 15px;
}
</style>